import * as React from "react";
import Axios from "../Components/Axios";
import Cookies from "../Components/Cookies";
import {IMaskInput} from "react-imask";
import {Alert} from "react-bootstrap";

const backendUrl = process.env.REACT_APP_BACKEND ?? '';
const smsCodeLifeTime = +process.env.REACT_APP_SMS_CODE_LIFETIME;


class Auth extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            service: this.props.match.params.service,
            agreeded: false,
            waitSms: false,
            code: '',
            invalidCode: false
        };
        if(Cookies.getSession()) {
            this.props.history.push('/');
        }
        setTimeout(()=>{
            try {
                document
                    .getElementsByClassName('buy-page')
                    .item(0)
                    .style
                    .opacity = 1;
            }
            catch (E){
            }
        }, 200);

        document.title = 'Авторизация';
    }

    getTimeout() {

        Axios
            .get(`api/service/timeout`)
            .then(r => {
                let timeout = r.data;
                if(!timeout) return;

                this.setState({
                    waitSms: true,
                    timeReaming: smsCodeLifeTime - timeout
                });

                this.timeReamingChange(this);
            });

    }

    componentDidMount() {
        this.getTimeout();
    }

    handleChange(e, field, parent = null) {

        let isCheckbox = e.target.type === 'checkbox';

        if(parent === null) {
            this.setState({
                [field]: isCheckbox ? e.target.checked : e.target.value
            });
        }
        else
        {
            let parentNode = this.state[parent];
            parentNode[field] = isCheckbox ? e.target.checked : e.target.value;
            this.setState({
                [parent]: parentNode
            });
        }
    }

    timeReamingChange(self) {
        self.setState({
            timeReaming: this.state.timeReaming <= 0 ? 0 : --self.state.timeReaming
        });
        if(self.state.timeReaming > 0)
            setTimeout(() => self.timeReamingChange(self), 1000);
        else
            console.log('done time');
    }

    formatTime(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.round(seconds % 60);
        return [
            h,
            m > 9 ? m : (h ? '0' + m : m || '0'),
            s > 9 ? s : '0' + s
        ].filter(Boolean).join(':');
    }

    auth() {

        this.setState({
            smsError: false,
            maxCount: false
        });

        Axios
            .post('api/auth', {
                msisdn: this.state.msisdn ? this.state.msisdn.replace(/\D/g, '') : null
            }, {
                withCredentials: true
            })
            .then(r => {
                if(!r?.success) {
                    this.setState({
                        smsError: r?.message
                    });
                    return;
                }

                this.setState({
                    waitSms: true,
                    timeReaming: smsCodeLifeTime,
                    smsError: null
                });
                this.timeReamingChange(this);
            });

    }

    handleSubmit(e) {
        e.preventDefault();
        this.auth();
    }


    handleSubmitSms(e) {
        e.preventDefault();
        Axios
            .post('api/auth/confirm_code', {
                code: this.state.code,
                msisdn: this.state.msisdn
            })
            .then(r => {
                    !r?.success
                        ? this.setState({ invalidCode: true, code: '' })
                        : this.props.history.push('/');
                    !r?.success && r?.message === 'Max count' && this.setState({
                        maxCount: true,
                        invalidCode: false,
                        code: ''
                    });
                }
            );

    }

    sendSms(self) {
        self.auth();
    }

    render() {
        return (
            <div className="container pt-3 pb-3 buy-page">
                <div className="card  shadow  border-0" style={{maxWidth: "500px", margin: "auto"}}>
                    <img className="card-img-top" style={{width:'100%'}} src= {`${backendUrl}images/auth.png`} alt="" />
                    <div className="card-body">

                        <h5 className="card-title mb-0">Авторизация</h5>
                        <br/>
                        {
                            !this.state.waitSms &&
                            <>
                                <form onSubmit={e => this.handleSubmit(e, this)}>
                                    {
                                        !!this.state?.smsError &&
                                        <Alert variant={'danger'}>{this.state?.smsError}</Alert>
                                    }
                                    <label htmlFor="" className="mt=4">Ваш номер телефона:</label>

                                    <IMaskInput
                                        mask={'{0}(000)00-00-00'}
                                        type="tel"
                                        className="form-control mb-4 mt-1"
                                        placeholder="0(555)11-22-33"
                                        value={this?.state?.msisdn ?? ''}
                                        onChange={e => this.handleChange(e, 'msisdn')}
                                    />
                                    <ul className="unstyled centered mb-2">
                                        <li>
                                            <input
                                                className="styled-checkbox"
                                                id="styled-checkbox-1"
                                                type="checkbox"
                                                required
                                                checked={this.state.agreeded}
                                                onChange={e => this.handleChange(e, 'agreeded')}
                                            />
                                            <label htmlFor="styled-checkbox-1">
                                                Согласен с условиями предоставления сервиса
                                            </label>
                                        </li>
                                    </ul>
                                    <button
                                        type="submit"
                                        className="btn btn-block btn-success"
                                        disabled={!this.state.agreeded || !this.state?.msisdn?.length}
                                    >
                                        Войти
                                    </button>
                                </form>
                            </>
                        }
                        {
                            this.state.waitSms &&
                            <>
                                {
                                    !this.state.maxCount &&
                                    <h6 className="card-title mt-0 text-success p-0">Вам выслан SMS-код, введите его:</h6>
                                }
                                <form onSubmit={e => this.handleSubmitSms(e, this)}>
                                    {
                                        this.state.invalidCode &&
                                        <Alert variant={'danger'}>Неправильный SMS-код</Alert>
                                    }
                                    {
                                        !!this.state.maxCount &&
                                        <Alert variant={'danger'}>
                                            { 'Превышено максимальное количество попыток ввода' }.
                                        </Alert>
                                    }
                                    {
                                        //!this.state.maxCount &&
                                        <>
                                            <input
                                                type="text"
                                                maxLength={4}
                                                value={this.state.code}
                                                className="form-control my-4"
                                                placeholder="XXXX"
                                                onChange={e => this.handleChange(e, 'code')}
                                                disabled={!!this.state.maxCount}
                                            />
                                            <button
                                                type="submit"
                                                className="btn btn-block btn-success"
                                                disabled={!!this.state.maxCount || this.state.code.length !== 4}
                                            >
                                                Подтвердить
                                            </button>
                                        </>
                                    }
                                    {
                                        !!this.state.timeReaming &&
                                        <h6
                                            className="card-title mt-4 text-center text-secondary p-0">
                                            Через <span
                                            id="timer">{this.formatTime(this.state.timeReaming ?? 0)}</span> можете
                                            повторно отправить SMS.
                                        </h6>
                                    }
                                    {
                                        !this.state.timeReaming &&
                                        <button type="button" className="btn btn-block mt-4 btn-primary" onClick={() => this.sendSms(this)}>
                                            Повторить SMS
                                        </button>
                                    }
                                </form>
                            </>
                        }
                    </div>
                </div>

            </div>
        );
    }

}

export default Auth;
